import React from "react";
import { Routes } from "react-router-dom";

import { GooseGamesRoute } from "src/shared/constants/route";
import { Permission } from "src/shared/contexts";
import NotFound from "src/views/404";

import { Route } from "../../shared/components";

import { GooseGamesContextProvider } from "./context";
import GooseGamesHackers from "./hackers";
import GooseGamesHome from "./home";
import GooseGamesQuests from "./quests";
import GooseGamesStore from "./store";

export const GooseGamesRoutes = () => (
  <GooseGamesContextProvider>
    <Routes>
      <Route
        path={GooseGamesRoute.HOME}
        element={<GooseGamesHome />}
        requirePermissions={[Permission.HACKER_EVENT_ACCESS]}
      />
      <Route
        path={GooseGamesRoute.QUESTS}
        element={<GooseGamesQuests />}
        requirePermissions={[Permission.ORGANIZER]}
      />
      <Route
        path={GooseGamesRoute.STORE}
        element={<GooseGamesStore />}
        requirePermissions={[
          Permission.HACKER_EVENT_ACCESS,
          Permission.ORGANIZER,
        ]}
        requireAll={false}
      />
      <Route
        path={GooseGamesRoute.HACKERS}
        element={<GooseGamesHackers />}
        requirePermissions={[Permission.ORGANIZER]}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </GooseGamesContextProvider>
);
